import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { PageWithLayout } from '../containers/page';


class AttributesPage extends Component {
    constructor(props) {
        super(props);

        this.registerSocketIOEvents = this.registerSocketIOEvents.bind(this);
        this.handleDeletePrompt = this.handleDeletePrompt.bind(this);
        this.state = {
            attributes: []
        };
    }


    componentDidMount() {
        this.props.handleLoader(true);

        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }

       
    }

    componentDidUpdate(prevProps) {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }
    }

    registerSocketIOEvents() {
        if (this.state._registeredEvents)
            return;

        this.setState({
            _registeredEvents: true
        });



        this.props.socketIOClient.on('attributes', (data) => {
            this.props.handleLoader(null);

            console.log(data);
            this.setState({
                attributes: data
            });
        });


        this.props.socketIOClient.emit('attributes', {category: this.props[0].match.params.cid});
    }



    handleDeletePrompt(answer, val) {
        console.log(val);
        if (answer) {
            this.props.socketIOClient.emit('deleteAttribute', {category: this.props[0].match.params.cid, attribute: val});
            this.props.openDeletePrompt(null, null);

        } else {
            this.props.openDeletePrompt(null, null);
        }
    }


    componentWillUnmount(){ if (!this.props.socketIOClient) return;
        this.props.socketIOClient.removeAllListeners("attributes");
    }

    render() {

        return (
            <div className="content">
            {

                                (!this.props.uData && !localStorage.uData) && <Redirect to='/login' />
      
              }
                <div className="panel panel-list">
                    <div>

                        <div className="title">
                            <h1>{this.props.translate('Attributes')}</h1>

                            <div className="button-wrap">
                                <Link to={`/categories/${this.props[0].match.params.cid}/attributes/new`} className="button" >{this.props.translate('Add new attrubute')}</Link>
                            </div>
                            <h6>{this.props.translate('List of attributes')}</h6>



                        </div>


                        <div className="table">
                            <table>
                            <tr className="text-row">
                                    <th>{this.props.translate('Name')}</th>
                                    <th>{this.props.translate('Alias')}</th>
                                    <th>{this.props.translate('Type')}</th>
                                    <th className="action-head">{this.props.translate('Action')}</th>
                                </tr>

                                {
                                    this.state.attributes.map((attribute) => {
                                        return (
                                            <tr className="text-row">
                                            <td>{attribute.name}</td>
                                                <td>{attribute.alias}</td>
                                                <td>{attribute.type}</td>
                                                <td>
                                                <Link to={`/categories/${this.props[0].match.params.cid}/attributes/${attribute._id}`} className="button" ><i className="mdi mdi-pencil"></i> </Link>
                                                    <button className="button" onClick={() => this.props.openDeletePrompt(attribute._id, this.handleDeletePrompt)}><i className="mdi mdi-delete"></i> </button>
                                                </td>
                                            </tr>


                                        )
                                    }
                                    )}

                            </table>

                        </div>


                    </div>

                </div>


            </div>
        );
    }
}

export default PageWithLayout(AttributesPage);


// WEBPACK FOOTER //
// ./src/views/attributesPage.js